var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 6.65685 8.65685 8 7 8C5.34315 8 4 6.65685 4 5C4 3.34315 5.34315 2 7 2C8.65685 2 10 3.34315 10 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10C4.46243 10 2 12.4624 2 15.5V21C2 21.5523 2.44772 22 3 22H20C21.1046 22 22 21.1046 22 20V15.5C22 12.4624 19.5376 10 16.5 10C14.6398 10 12.9954 10.9234 12 12.3369C11.0046 10.9234 9.36016 10 7.5 10ZM8 15.9568C8 13.534 10.2001 12.6295 12 14.501C13.7999 12.6295 16 13.534 16 15.9568C16 17.4071 14.3922 18.941 13.2153 19.8695C12.6825 20.2898 12.4161 20.5 12 20.5C11.5839 20.5 11.3175 20.2898 10.7847 19.8695C9.60777 18.9409 8 17.4071 8 15.9568Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C20 6.65685 18.6569 8 17 8C15.3431 8 14 6.65685 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyAlt);
export default __webpack_public_path__ + "static/media/family-alt.afd8e228e8f984b35831bd3275f6bc47.svg";
export { ForwardRef as ReactComponent };